import React, { useState } from 'react';
import { useSecurity } from '../../../helpers/SecurityHooks';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { appendScriptsCallback, formatDate, formatDateTime } from '../../../helpers/Utils';
import { useParams } from 'react-router-dom';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { getEntityDetails, getPreferredDetails  } from '../../../../services/ApiServices';

export function TradingAgencyProfilePeriodNewPage(): React.ReactElement {
  const [state, setState] = useState<ITradingAgencyProfilePeriod>({ Id: "" , LoadingInfo: {}  });
  const currentSecurity = useSecurity('Trading', 'AgencyProfilePeriod');
  const updatedState: ITradingAgencyProfilePeriod = { Id: "" , LoadingInfo: {}  };
  React.useEffect(() => {
    if (currentSecurity.checkAccess()) {
            updatedState.ForecastYear = new Date().getFullYear().toString();
            updatedState.StartDate = new Date().toString();
            updatedState.EndDate = new Date().toString();
            const date = new Date();
            const startDate = new Date(Date.UTC(date.getFullYear(), date.getMonth() + 1, 1));
            const endDate = new Date(Date.UTC(date.getFullYear(), date.getMonth() + 3, -1));
            updatedState.StartDate = startDate.toISOString();
            updatedState.EndDate = endDate.toISOString();
            updatedState.Status = 0;
            updatedState.BreakCriteria = 2;
      setState(updatedState);
      appendScriptsCallback(["Areas/Trading/Scripts/Resources/en/res.AgencyProfilePeriod.en.js",
        "Areas/Trading/Scripts/Resources/en/Types.en.js",
        "Areas/Trading/Scripts/Enums.js",
        "Areas/Trading/Scripts/AgencyProfilePeriod/View.js"], "initNewTradingAgencyProfilePeriod", { viewmodel : updatedState, canEdit: true, canCreate: true, canRemove: true, });
    }
  }, []);
  return (
    <div className="container-fluid">
      <section id="patron">
        <section className="content">
          <div className="clear"></div>
          <section id="viewContent">
          <div id="AgencyProfilePeriod" className="controls-container default block">
              <h3>Create a New <b>Forecast Periods</b></h3>
              <p>Please fill in the fields, once completed click on Save to proceed with the creation:</p>
              <form id="form" action="" className="content-view row">
		<div className="col-md-2" ><label>Code</label><input id="AgencyProfilePeriodCode" max="20" name="Code" type="text" defaultValue={state.Code} className="shortcontrol disabled k-input k-input-solid k-textbox" readOnly disabled  placeholder="AUTO-CODE" /></div>
			<div className="col-md-2">
				<label id="AgencyProfilePeriodLabelBlockedCode">Blocked</label>
				<input id="AgencyProfilePeriodCheckBlockedCode" defaultChecked name="AgencyProfilePeriodCheckBlockedCode" type="checkbox" />
			</div>
			<div className="clear"></div>
		<div className="col-md-4 combobox  " ><label htmlFor="AgencyId">Agency</label><select className="" id="AgencyProfilePeriodAgencyId" name="AgencyId" defaultValue={state.AgencyId}   required data-required-msg="Agency is required"  >{state.AgencyId && <option value={state.AgencyId}>{state.AgencyDisplayValue}</option>}</select></div>
		<div className="col-md-4" ><label htmlFor="Alias">Alias</label><input  required data-required-msg="Alias is required"  id="AgencyProfilePeriodAlias" name="Alias" type="text" defaultValue={state.Alias} className="k-input k-input-solid k-textbox" /></div>
        <div className="clear"></div>
		<div className="field textareafield"><label htmlFor="Comments">Comments</label><div><textarea className="k-input k-textbox" cols={20} id="AgencyProfilePeriodComments" name="Comments" maxLength={2147483647} rows={5} defaultValue={state.Comments}></textarea></div></div>
		<div className="col-md-2 dropdownlist  " >
      <label htmlFor="BreakCriteria" className="required">Break Criteria</label>
      <select className="" id="AgencyProfilePeriodBreakCriteria" name="BreakCriteria" value={state.BreakCriteria} required data-required-msg="Break Criteria is required" >
        <option value="3">Month</option>
        <option value="2">Quarter</option>
        <option value="1">Half Annual</option>
        <option value="0">Annual</option>
      </select>
    </div>
		<div className="col-md-2 dropdownlist  " >
      <label htmlFor="Period" className="required">Period</label>
      <select className="" id="AgencyProfilePeriodPeriod" name="Period" value={state.Period} required data-required-msg="Period is required" >
        <option value="0">Budget</option>
        <option value="1">Q1</option>
        <option value="2">Q2</option>
        <option value="3">Q3</option>
        <option value="4">Full-Year</option>
      </select>
    </div>
		<div className="col-md-2 dropdownlist  " >
      <label htmlFor="Status" className="required">Status</label>
      <select className="" id="AgencyProfilePeriodStatus" name="Status" value={state.Status} required data-required-msg="Status is required" >
        <option value="0">Pending</option>
        <option value="1">Submitted</option>
        <option value="2">Approved</option>
        <option value="3">Closed</option>
        <option value="4">Error</option>
      </select>
    </div>
        <div className="clear"></div>
		<div className="col-md-2" ><label htmlFor="StartDate">Start Date</label><input  required data-required-msg="Start Date is required"  id="AgencyProfilePeriodStartDate" name="StartDate"  type="text" defaultValue={state.StartDate} className="k-input k-input-solid k-textbox" /></div>
		<div className="col-md-2" ><label htmlFor="EndDate">End Date</label><input  required data-required-msg="End Date is required"  id="AgencyProfilePeriodEndDate" name="EndDate"  type="text" defaultValue={state.EndDate} className="k-input k-input-solid k-textbox" /></div>
		<div className="col-md-2" ><label htmlFor="ForecastYear">Forecast Year</label><input  required data-required-msg="Forecast Year is required"  data-val-number="The field Forecast Year must be a number." id="AgencyProfilePeriodForecastYear" name="ForecastYear" type="text" defaultValue={state.ForecastYear} className="k-input k-textbox" /></div>
		<div className="col-md-4" ><label htmlFor="SourceReference">Source Reference</label><input id="AgencyProfilePeriodSourceReference" max="60" name="SourceReference" type="text" defaultValue={state.SourceReference} className="shortcontrol k-input k-input-solid k-textbox"  placeholder="SOURCE-REFERENCE" /></div>
              </form>
              <section className="button-toolbar" id="ToolbarAgencyProfilePeriod">
                <div className="left">
                  <button id="cancelAgencyProfilePeriodButton" type="button" className="k-button button" title="Cancel">Cancel</button>
                </div>
		            <div className="right">
                  <button id="saveAgencyProfilePeriodButton" type="button" className="k-button button" title="Save">Save</button>
                </div>
              </section>
            </div>
          </section>
        </section>
      </section>
    </div>
  );
}

interface ITradingAgencyProfilePeriod {
  LoadingInfo: {
    CreationDate?: string,
    CreatedBy?: string,
    CreatedByDisplayValue?: string,
    UpdateDate?: string,
    UpdatedBy?: string,
    UpdatedByDisplayValue?: string,
    SourceStatus?: number,
    Source?: number
  },
  AgencyId?: string,
  AgencyDisplayValue?: string,
  Alias?: string,
  Comments?: string,
  BreakCriteria?: number,
  Period?: number,
  Status?: number,
  StartDate?: string,
  EndDate?: string,
  ForecastYear?: string,
  Code?: string,
  Display?: string,
  EntityStatus?: number,
  SourceReference?: string,
  Id: string,
  InactiveFrom?: Date
}

	
// eslint-disable-next-line @typescript-eslint/no-unused-vars
enum DealBreakTypeEnum { 'Month' = 3, 'Quarter' = 2, 'Half Annual' = 1, 'Annual' = 0 }
	
// eslint-disable-next-line @typescript-eslint/no-unused-vars
enum SubmissionStatusEnum { 'Pending' = 0, 'Submitted' = 1, 'Approved' = 2, 'Closed' = 3, 'Error' = 4 }
	
// eslint-disable-next-line @typescript-eslint/no-unused-vars
enum ForecastQuarterEnum { 'Budget' = 0, 'Q1' = 1, 'Q2' = 2, 'Q3' = 3, 'Full-Year' = 4 }

export function TradingAgencyProfilePeriodDetailPage(): React.ReactElement {
  const { id } = useParams();
  const [state, setState] = useState<ITradingAgencyProfilePeriod>({ Id: "" , LoadingInfo: {}  });
  const currentSecurity = useSecurity('Trading', 'AgencyProfilePeriod');
  React.useEffect(() => {
    if (state.Id == "" && currentSecurity.checkAccess()) {
      getEntityDetails("Trading", "AgencyProfilePeriod", id).then(result => {
        setState(result.Value[0] as ITradingAgencyProfilePeriod);
        appendScriptsCallback(["Areas/Trading/Scripts/Resources/en/res.AgencyProfilePeriod.en.js",
        "Areas/Trading/Scripts/Resources/en/Types.en.js",
        "Areas/Trading/Scripts/Enums.js",
        "Areas/Trading/Scripts/AgencyProfilePeriod/View.js"
        ,"Areas/Trading/Scripts/Resources/en/res.ClientProfilePeriod.en.js"
        ,"Areas/Trading/Scripts/ClientProfilePeriod/View.js"
        ], "initDetailTradingAgencyProfilePeriod", { viewmodel: result.Value[0], canEdit: true, canCreate: true, canRemove: true, id: id});
      });
    }
  }, []);
  window['reloadTradingAgencyProfilePeriodState'] = (data) => {
    setState(data.Value[0] as ITradingAgencyProfilePeriod);
  };
  return (
    <div className="container-fluid">
      <section id="patron" style={{ display: 'none' }}>
        <section className="content">
          <div className="clear"></div>
          <section id="viewContent">
            <div id="AgencyProfilePeriod" className="controls-container default block">
              <div className="content-label">
                <div className="content-title">
                    <div className="k-content">
                        <h3>Forecast Periods: <span>{state.Display}</span><span id="AgencyProfilePeriodToggle" className="k-icon k-i-media-manager" style={{ cursor: 'pointer' }} ></span></h3>
                    </div>
                </div>
                <div className='content-line'>
                  {state.AgencyId && <span className='element'><label>Agency: <label className="strong">{state.AgencyDisplayValue}</label></label></span>}
                  <span className='element'><label>Break Criteria: <label className="strong">{state.BreakCriteria != undefined ? DealBreakTypeEnum[state.BreakCriteria] : ''}</label></label></span>
                  <span className='element'><label>Start Date: <label className="strong">{formatDate(state.StartDate)}</label></label></span>
                </div>
                <div className='content-line'>
                  <span className='element'><label>End Date: <label className="strong">{formatDate(state.EndDate)}</label></label></span>
                </div>
              </div>
              <form id="form" action="" style={{ display: 'none'}} className="content-view row">
		<div className="col-md-2" ><label>Code</label><input id="AgencyProfilePeriodCode" max="20" name="Code" type="text" defaultValue={state.Code} className="shortcontrol disabled k-input k-input-solid k-textbox" readOnly disabled  placeholder="AUTO-CODE" /></div>
			<div className="col-md-2">
				<label id="AgencyProfilePeriodLabelBlockedCode">Blocked</label>
				<input id="AgencyProfilePeriodCheckBlockedCode" defaultChecked name="AgencyProfilePeriodCheckBlockedCode" type="checkbox" />
			</div>
			<div className="clear"></div>
		<div className="col-md-4 combobox  " ><label htmlFor="AgencyId">Agency</label><select className="" id="AgencyProfilePeriodAgencyId" name="AgencyId" defaultValue={state.AgencyId}   required data-required-msg="Agency is required"  >{state.AgencyId && <option value={state.AgencyId}>{state.AgencyDisplayValue}</option>}</select></div>
		<div className="col-md-4" ><label htmlFor="Alias">Alias</label><input  required data-required-msg="Alias is required"  id="AgencyProfilePeriodAlias" name="Alias" type="text" defaultValue={state.Alias} className="k-input k-input-solid k-textbox" /></div>
        <div className="clear"></div>
		<div className="field textareafield"><label htmlFor="Comments">Comments</label><div><textarea className="k-input k-textbox" cols={20} id="AgencyProfilePeriodComments" name="Comments" maxLength={2147483647} rows={5} defaultValue={state.Comments}></textarea></div></div>
		<div className="col-md-2 dropdownlist  " >
      <label htmlFor="BreakCriteria" className="required">Break Criteria</label>
      <select className="" id="AgencyProfilePeriodBreakCriteria" name="BreakCriteria" value={state.BreakCriteria} required data-required-msg="Break Criteria is required" >
        <option value="3">Month</option>
        <option value="2">Quarter</option>
        <option value="1">Half Annual</option>
        <option value="0">Annual</option>
      </select>
    </div>
		<div className="col-md-2 dropdownlist  " >
      <label htmlFor="Period" className="required">Period</label>
      <select className="" id="AgencyProfilePeriodPeriod" name="Period" value={state.Period} required data-required-msg="Period is required" >
        <option value="0">Budget</option>
        <option value="1">Q1</option>
        <option value="2">Q2</option>
        <option value="3">Q3</option>
        <option value="4">Full-Year</option>
      </select>
    </div>
		<div className="col-md-2 dropdownlist  " >
      <label htmlFor="Status" className="required">Status</label>
      <select className="" id="AgencyProfilePeriodStatus" name="Status" value={state.Status} required data-required-msg="Status is required" >
        <option value="0">Pending</option>
        <option value="1">Submitted</option>
        <option value="2">Approved</option>
        <option value="3">Closed</option>
        <option value="4">Error</option>
      </select>
    </div>
        <div className="clear"></div>
		<div className="col-md-2" ><label htmlFor="StartDate">Start Date</label><input  required data-required-msg="Start Date is required"  id="AgencyProfilePeriodStartDate" name="StartDate"  type="text" defaultValue={state.StartDate} className="k-input k-input-solid k-textbox" /></div>
		<div className="col-md-2" ><label htmlFor="EndDate">End Date</label><input  required data-required-msg="End Date is required"  id="AgencyProfilePeriodEndDate" name="EndDate"  type="text" defaultValue={state.EndDate} className="k-input k-input-solid k-textbox" /></div>
		<div className="col-md-2" ><label htmlFor="ForecastYear">Forecast Year</label><input  required data-required-msg="Forecast Year is required"  data-val-number="The field Forecast Year must be a number." id="AgencyProfilePeriodForecastYear" name="ForecastYear" type="text" defaultValue={state.ForecastYear} className="k-input k-textbox" /></div>
		<div className="col-md-4" ><label htmlFor="SourceReference">Source Reference</label><input id="AgencyProfilePeriodSourceReference" max="60" name="SourceReference" type="text" defaultValue={state.SourceReference} className="shortcontrol k-input k-input-solid k-textbox"  placeholder="SOURCE-REFERENCE" /></div>
                <div className="clear"></div>
                <div className="content-header">Tracking</div>
                <div className="col-md-4" ><label htmlFor="LoadingInfo_SourceStatus">Loading Status</label><select className="" id="AgencyProfilePeriodSourceStatus" name="LoadingInfo.SourceStatus" value={state.LoadingInfo.SourceStatus} ><option value="0">Loaded</option><option value="1">Processed</option><option value="2">Pending</option><option value="3">Reloaded</option><option value="4">Error</option></select></div><div className="col-md-4" ><label htmlFor="LoadingInfo_Source">Source</label><select className="" id="AgencyProfilePeriodSource" name="LoadingInfo.Source" value={state.LoadingInfo.Source} ><option value="0">Owned</option><option value="1">ExternalPlanning</option><option value="2">ExternalBuying</option><option value="3">ExternalFinance</option><option value="4">ExternalHub</option></select></div><div className="clear"></div>
                <div className="trackinfo">
                    <div className="line">Created on <span className="when">{formatDateTime(state.LoadingInfo.CreationDate)}</span> by <span className="who">{state.LoadingInfo.CreatedByDisplayValue}</span> </div>
                    <div className="line">Last Update on <span className="when">{formatDateTime(state.LoadingInfo.UpdateDate)}</span> by <span className="who">{state.LoadingInfo.UpdatedByDisplayValue}</span> </div>
                </div>
              </form>
              <section className="button-toolbar" style={{ display: 'none'}} id="ToolbarAgencyProfilePeriod">
                <div className="left">
                  <button id="cancelAgencyProfilePeriodButton" type="button" className="k-button button" title="Cancel">Cancel</button>
                </div>
		            <div className="right">
                  <button id="saveAgencyProfilePeriodButton" type="button" className="k-button button" title="Save">Save</button>
                </div>
              </section>
            </div>
          </section>
            <div id="associationAgencyProfilePeriodClientProfilePeriod">
              <div className="k-block grid-details">
                <h2>Forecast Periods by Client</h2>
                <div id="ClientProfilePeriodGrid" className="grid-control"></div>
              </div>
            </div>
        </section>
      </section>
    </div>
  );
}


